import get from 'lodash/get';
import ent from 'ent';

export const Message = data => {
  return {
    id: data.id,
    body: ent.decode(data.body || ''),
    createdAt: data.createdAt ? Date.parse(data.createdAt) : null,
    trackingId: data.trackingId,
    sessionId: data.sessionId,
    campaignId: data.campaignId,
    sentBy: {
      id: get(data, 'sentBy.id', '__team'),
      type: get(data, 'sentBy.type', 'user'),
    },
    attachments: data.attachments,
    meta: get(data, 'meta'),
  };
};

export const responseDataToMessage = responseData => {
  return new Message({
    id: get(responseData, 'id'),
    body: get(responseData, 'attributes.body'),
    createdAt: get(responseData, 'attributes.createdAt'),
    trackingId: get(responseData, 'attributes.trackingId'),
    sessionId: get(responseData, 'relationships.session.data.id'),
    campaignId: get(responseData, 'relationships.campaign.data.id'),
    sentBy: get(responseData, 'relationships.sentBy.data', {}),
    attachments: get(responseData, 'relationships.attachments.data'),
    meta: get(responseData, 'attributes.meta'),
  });
};

export const responseToMessageList = response => {
  return response.data.data.map(responseDataToMessage).reverse();
};

export const responseToMessage = response => {
  return responseDataToMessage(response.data.data);
};
